var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Restritivos_ReembolsoActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Restritivos_ReembolsoModule = class Restritivos_ReembolsoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Restritivos_ReembolsoActions.POST_RESTRITIVOS_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.post("Restritivos_Reembolso/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Restritivos_ReembolsoActions.PUT_RESTRITIVOS_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.put("Restritivos_Reembolso/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Restritivos_ReembolsoActions.DELETE_RESTRITIVOS_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.delete("Restritivos_Reembolso/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Restritivos_ReembolsoActions.DELETE_RANGE_RESTRITIVOS_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.delete("Restritivos_Reembolso/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Restritivos_ReembolsoActions.FILTER_RESTRITIVOS_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.post("Restritivos_Reembolso/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Restritivos_ReembolsoActions.GET_RESTRITIVOS_REEMBOLSO]() {
        return new Promise(resolve => {
            fornecService.get("Restritivos_Reembolso/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Restritivos_ReembolsoActions.GETWITHDISABLED_RESTRITIVOS_REEMBOLSO]() {
        return new Promise(resolve => {
            fornecService.get("Restritivos_Reembolso/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Restritivos_ReembolsoActions.GET_BY_ID_RESTRITIVOS_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.get("Restritivos_Reembolso/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Restritivos_ReembolsoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Restritivos_ReembolsoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Restritivos_ReembolsoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Restritivos_ReembolsoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Restritivos_ReembolsoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Restritivos_ReembolsoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Restritivos_ReembolsoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Restritivos_ReembolsoModule.prototype, _h, null);
Restritivos_ReembolsoModule = __decorate([
    Module
], Restritivos_ReembolsoModule);
export default Restritivos_ReembolsoModule;
//# sourceMappingURL=Restritivos_ReembolsoModule.js.map